var React = require('react');

function Cross (props) {
    return React.createElement("svg",props,React.createElement("g",{"fillRule":"evenodd"},React.createElement("path",{"d":"M25.152 5.82l1.029 1.028L17.028 16l9.153 9.152-1.029 1.029L16 17.028l-9.152 9.153-1.029-1.029L14.972 16 5.82 6.848l1.029-1.029L16 14.972z"})));
}

Cross.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = Cross;

Cross.default = Cross;
